import styled from 'styled-components';
import GoogleLogin from "react-google-login";
import {colors} from "../Constants/Constants";


export const Wrapper = styled.div`
  display: flex;
 flex-direction: column;
 text-align: -webkit-center;
 background: ${colors.lightWhite};
`;

export const LoginC = styled.div`
 width: 100%;
 height: 90px;
 background: ${colors.orange};
 display: flex;
 align-items: center;
 justify-content: space-between;
 position: fixed;
  z-index: 1001;
  top: 0;
  backface-visibility: hidden;
  padding: 10px;
`;
export const LoginButton = styled(GoogleLogin)`
 width: 200px;
 margin-right: 10px;
`;

export const Text = styled.h1`
 font-family: 'Work Sans', sans-serif;
 color: white;
 font-size: 3em;
 margin-bottom: 0px;
`;

export const AboutUs = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;
    justify-content: space-around;
    width: 80%;
    margin-left: 10px;
    align-items: center;
    margin-bottom: 10px;
    padding: 10px;
    align-self: center;
`;

export const HowItWorks = styled.div`
  display: flex;
 flex-direction: row;
 margin-top: 10px;
 justify-content: space-around;
 width: 65%;
 margin-left: 10px;
 align-items: center;
 margin-bottom: 10px;
 padding: 10px;
 flex-wrap: wrap;
`;

export const Platforms = styled.div`
  display: flex;
 flex-direction: row;
 justify-content: space-around;
 width: 80%;
 align-items: center;
 margin-bottom: 20px;
 padding: 10px;
 align-self: center;
 flex-wrap: wrap;
`;

export const Header = styled.div`
 background: ${colors.darkOrange};
 height: 380px;
 width: 100%; 
 display: flex; 
 flex-direction: column;
 border-bottom-right-radius: 100px;
 margin-top: 80px;
 align-items:center;
 justify-content: space-evenly;
`;

export const Title = styled.h2`
  font-family: 'Work Sans', sans-serif;
  font-weight: 300;
  font-size: 30px;
  color: lightslategray;
`;

export const Description = styled.p`
  font-family: 'Work Sans', sans-serif;
  text-align: left;
  color: ${colors.dark};
  font-size: 18px;
  margin-bottom: 0px;
`;
export const HeaderDescription = styled.p`
  font-family: 'Work Sans', sans-serif;
  color: white;
  font-size: 35px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  margin-bottom: 0px;
  background-color: ${colors.orange};
  justify-content: space-evenly;
`;

export const PrivacyWrapper = styled.div`
  padding: 30px;
  padding-top: 30px;
  margin-top: 30px;
`;

export const PrivacyTitle = styled.h1`
  font-family: 'Work Sans', sans-serif;
  margin: 0;
  padding: 10px;
  font-weight: 500;
  font-size: 40px;
  color: lightslategray;
`;
export const PrivacyDescription = styled.p`
   margin: 0;
  padding: 10px;
  color: ${colors.dark};
  font-family: 'Work Sans', sans-serif;
  line-height: 27px;
  text-align: left;
  font-size: 18px;
  white-space: pre-line;
`;

export const Subtitle = styled.h2`
   margin: 0;
  padding: 10px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 300;
  color: lightslategray;
  text-align: left;
`;

export const ListWrapper = styled.div`
 display: flex;
 flex-direction: row;
 justify-content:space-around;
 flex-wrap: wrap;
 width: 100%;
 padding: 10px;
 
`;

export const FilterBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    
`
export const FilterText = styled.h2`
   font-family: 'Work Sans', sans-serif;
   color: lightslategray;
   margin-top: 18px;
   
   `
export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Legend = styled.div`
   background-color: #fff;
   border-radius: 3px;
   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
   padding: 10px;
   position: relative;
   z-index: 1;
   float: right;
   text-align:center;
   width: 130px;
`

export const MobileLegend = styled.div`
   display: flex;
   justify-content: space-between;
   background-color: #fff;
   border-radius: 3px;
   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
   position: relative;
   z-index: 1;
   float: right;
   text-align:center;
`

export const MobileLegent = styled.div`
   background-color: #fff;
   border-radius: 3px;
   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
   padding: 10px;
   z-index: 1;
   height: 50px;
   width: 100%;
   display: flex;
   flex-direction: row;
`
export const LegendElements = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;


